const markup =
  '<div class="quantity-button quantity-down">–</div>' +
  '<div class="quantity-button quantity-up">+</div>';

// TODO: make this work only for .cart and .product
let $quantity = $('.js-form-type-number', context);

$quantity.once('quantity-field').each(function() {
  let $this = $(this);
  $this.append(markup);

  let $input = $this.find('input[type="number"]');
  let $btnUp = $this.find('.quantity-up');
  let $btnDown = $this.find('.quantity-down');
  let min = $input.attr('min');
  let max = $input.attr('max');

  $btnUp.on('click', function() {
    var oldValue = parseFloat($input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    $this.find('input').val(newVal);
    $this.find('input').trigger('change');
  });

  $btnDown.on('click', function() {
    var oldValue = parseFloat($input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    $this.find('input').val(newVal);
    $this.find('input').trigger('change');
  });
});
